export default function PhoneMockup() {
  return (
    <div
      className="relative z-10 rounded-[32px] border-[5px] border-neutral-800 bg-neutral-900 shadow-2xl shadow-black/40 overflow-hidden"
      style={{ width: 240, aspectRatio: '1080/2267' }}
    >
      <img
        src="/landing/step-1.png"
        alt="와우오더 앱 화면"
        className="w-full h-full object-cover"
      />
    </div>
  );
}
